import UsersSelectroPresenterDefinition from './UsersSelectroPresenterDefinition';
import InitiativesSelectroPresenterDefinition from './InitiativesSelectroPresenterDefinition';
import StrategicImperativesSelectroPresenterDefinition from './StrategicImperativesSelectroPresenterDefinition';

// Singleton instance of the UsersSelectroPresenterDefinition
export const UsersSelectroPresenter =
  UsersSelectroPresenterDefinition.getInstance();

// Singleton instance of the InitiativesSelectroPresenterDefinition
export const InitiativesSelectroPresenter =
  InitiativesSelectroPresenterDefinition.getInstance();

// Singleton instance of the StrategicImperativesSelectroPresenterDefinition
export const StrategicImperativesSelectroPresenter =
  StrategicImperativesSelectroPresenterDefinition.getInstance();
